<template>
    <div class="relative">
        <div class="related" v-if="_.has(log, 'logtype')">
            Gerelateerd
        </div>
        <div class="invoice-log" :class="{ 'fromuser': !_.isNull(log.user), 'related-log': _.has(log, 'logtype') }" v-if="type == 'normal'">
            <div class="content">
                <span class="log-actions" v-if="log.type == 'message' && (!_.isNull(log.user) && log.user != 0) && propsType != 'escalation'">
                    <b-tooltip label="Opmerking bewerken" position="is-top">
                        <b-button type="is-dark" outlined size="is-small" @click="$emit('edit-log', log)" icon-right="edit" />
                    </b-tooltip>
                    <b-tooltip label="Opmerking verwijderen" position="is-top">
                        <b-button type="is-danger" outlined size="is-small" @click="$emit('delete-log', log)" icon-right="trash-alt" />
                    </b-tooltip>
                </span>

                <span v-if="log.type !== 'message' && log.type !== 'payment_cancelled' && log.type !== 'customer_mail' && log.type !== 'invoice_products_changes'">
                    <p>{{ returnText(log.type, log.status) }}</p>

                    <div v-if="log.type == 'send_invoice_reminder1' || log.type == 'send_invoice_reminder2' || log.type == 'send_invoice_reminder3' || log.type == 'payment_error'">
                        <hr>
                        <p v-html="log.longtext" style="white-space: break-spaces;"></p>
                    </div>
                </span>
                <div v-if="log.type == 'invoice_products_changes'">
                    <p>Factuurproducten zijn aangepast.</p>
                    <p v-html="log.longtext" style="white-space: break-spaces;"></p>
                </div>
                <div v-if="log.type == 'payment_cancelled'">
                    {{ returnText(log.type, log.status) }}<br><br>
                    <strong>Reden:</strong><br>
                    {{ this.log.longtext }}
                </div>
                <div v-if="log.type == 'message' && log.type !== 'send_storno_mail'">
                    <p v-html="log.longtext" style="white-space: break-spaces;"></p>
                </div>
                <div v-if="log.type == 'send_storno_mail'">
                    <h5>Verzonden e-mail:</h5>
                    <p v-html="log.longtext" style="white-space: break-spaces;"></p>
                </div>
                <div v-if="log.type == 'customer_mail'" class="customer-mail-log">
                    <h5>E-mail verstuurd naar klant</h5>
                    <p><strong>Onderwerp</strong><br>{{ log.status || 'Geen onderwerp' }}</p>
                    <br>
                    <p class="marginbottom0"><strong>Bericht</strong><br><span v-html="log.longtext" style="white-space: break-spaces;"></span></p>
                </div>

                <div class="file" v-if="log.file && !hidebuttons && !log.type.includes('escalation_')">
                    <b-button type="is-primary" @click="viewFile(log.file.replace('/uploads', ''))">Bestand bekijken</b-button>
                </div>

                <div v-if="log.type == 'create_separated_credit' && !_.isNull(log.longtext) && !hidebuttons && !!log.status">
                    <b-button tag="router-link" :to="{ name: 'credit_outgoing_payment', params: {type: 'recent', id: log.longtext} }" type="is-primary">Bekijk bijbehorende factuur</b-button>
                </div>

                <!-- Link to created credit invoice when logged on original invoice -->
                <div v-if="log.type == 'credit_created_for_invoice' && !_.isNull(log.longtext) && !hidebuttons">
                    <b-button tag="router-link" :to="{ name: 'InvoicesRecord', params: {type: 'credit', id: log.status} }" type="is-primary">Bekijk creditfactuur</b-button>
                </div>

                <div v-if="log.type == 'credit_payment_applied' && !_.isNull(log.longtext) && !hidebuttons">
                    <b-button tag="router-link" :to="{ name: 'InvoicesRecord', params: {type: 'credit', id: log.status} }" type="is-primary">Bekijk creditfactuur</b-button>
                </div>

                <div v-if="log.type == 'create_invoice' && log.status == 'contract' && !hidebuttons">
                    <b-button tag="router-link" :to="{ name: 'InvoicesRecord', params: {type: 'recent', id: log.invoice} }" type="is-primary">Bekijk bijbehorende factuur</b-button>
                </div>

                <div v-if="log.type == 'credit_outgoing_payment' && !hidebuttons">
                    <b-button tag="router-link" :to="{ name: 'InvoicesRecord', params: {type: 'recent', id: log.status} }" type="is-primary">Bekijk bijbehorende factuur</b-button>
                </div>

                <div v-if="log.type == 'paynl_incasso_error' && !hidebuttons">
                    <a class="button is-primary" target="_blank" href="https://docs.pay.nl/developers?language=nl#direct-debit-error">Pay.nl status errors</a>
                </div>

                <div v-if="(log.type == 'invoice_contract_pricechange' || log.type == 'contract_pricechange') && !_.isNull(log.longtext) && !hidebuttons">
                    <b-button tag="router-link" :to="{ name: 'ContractsPriceChangesRecord', params: {id: log.longtext} }" type="is-primary">Bekijk prijswijziging</b-button>
                </div>
                <div v-if="(log.type == 'invoice_contract_addendum' || log.type == 'contract_addendum_requested' || log.type == 'contract_addendum_applied' || log.type == 'invoice_contract_addendum_restored') || log.type == 'contract_addendum_expired' && !_.isNull(log.longtext) && !hidebuttons">
                    <b-button tag="router-link" :to="{ name: 'ContractsAddendumsRecord', params: {id: log.longtext} }" type="is-primary">Bekijk contractaanpassing</b-button>
                </div>
            </div>

            <div class="meta">
                <p v-if="_.has(log, 'logtype')">
                    <span v-if="log.logtype === 'invoice'">
                        <router-link :to="{ name: 'InvoicesRecord', params: {type: 'recent', id: (log.invoice?.id || log.invoice)} }">Factuur #{{ (log.invoice?.number || log.invoice_number) }}</router-link>
                    </span>
                    <span v-else-if="log.logtype === 'contract'">
                        <router-link :to="{ name: 'ContractsRecordView', params: {id: log.contract.id} }">Contract #{{ log.contract.id }}</router-link>
                    </span>
                </p>
                <p class="date">
                    {{ moment(log.created_at).format('DD-MM-Y [om] HH:mm') }}
                    <br v-if="_.has(log, 'user_edited') && !_.isNull(log.user_edited)">
                    <small v-if="_.has(log, 'user_edited') && !_.isNull(log.user_edited)">
                        {{ `Laatst bewerkt op ${moment(log.updated_at).format('DD-MM-Y [om] HH:mm')}` }}
                        <span v-if="log.user_edited && log.user_edited.name"> door {{ log.user_edited.name }}</span>
                    </small>
                </p>
                <p class="user">
                    {{ _.isNull(log.user) ? 'PlanitEasyBOT' : log.user.name }}
                    <span v-if="!_.isNull(log.user) && log.user.deurwaarder == 1">(deurwaarder)</span>
                </p>
            </div>
        </div>
        <div v-else class="invoice-log simple">
            <p>
                <span v-if="log.type !== 'message' && log.type !== 'invoice_products_changes'">
                    {{ returnText(log.type, log.status) }}

                    <div v-if="log.type == 'send_invoice_reminder1' || log.type == 'send_invoice_reminder2' || log.type == 'send_invoice_reminder3'">
                        <hr>
                        <p v-html="log.longtext" style="white-space: break-spaces;"></p>
                    </div>
                </span>
                <span v-if="log.type == 'invoice_products_changes'">
                    <p v-html="log.longtext" style="white-space: break-spaces;"></p>
                </span>

                <span class="float-right text-right">{{ moment(log.created_at).format('DD-MM-Y [om] HH:mm') }}<br>{{ _.isNull(log.user) ? 'PlanitEasyBOT' : log.user.name }}</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InvoiceLog',

    data() {
        return {
            type: 'normal'
        }
    },

    props: {
        log: {
            type: Object,
            required: true
        },
        hidebuttons: {
            type: Boolean,
            required: false,
            default: false,
        },
        propsType: {
            type: String,
            required: false
        }
    },

    methods: {
        returnText(type, status, date){
            switch(type){
                // Invoice types
                case 'send_invoice_mail':
                    if(status == 'invoice_paid')
                        return 'E-mail verzonden met de betaalbevestiging als bijlage.'
                    else if(status == 'invoice')
                        return 'E-mail verzonden met de factuur als bijlage.'
                    else if(status == 'failed')
                        return 'E-mail verzonden dat de betaling mislukt is en over 7 dagen opnieuw geprobeerd wordt het bedrag te incasseren.'
                    else if(status == 'credit')
                        return 'E-mail verzonden met de creditfactuur als bijlage.'
                break;
                case 'invoice_payment':
                    if(status == 1)
                        return 'Incasso betaling geslaagd.'
                    else if(status == 0){
                        return 'Incasso betaling mislukt.'
                    }
                break;
                case 'create_invoice_pdf':
                    if(status == 'paid')
                        return 'Betaalbevestiging PDF gegenereerd.'
                    else if(_.isNull(status))
                        return 'Factuur PDF gegenereerd.'
                    else
                        return 'Bestand gegenereerd.'
                break;
                case 'create_invoice_payment_adjustment':
                    return 'Betaling opnieuw ingepland voor '+moment(this.log.date).format('DD-MM-Y')+'.'
                break;
                case 'create_invoice_payment':
                case 'create_invoice_payment_hold':
                    let message = ''
                    if(status == 'incasso'){
                        message = 'Incasso betaling ingepland voor '+moment(this.log.date).format('DD-MM-Y')+'.'
                    } else if(status == 'manual') {
                        message = `Handmatige betaling (overschrijving) aangenomen van € ${parseFloat(this.log.longtext).toFixed(2)} op ${moment(this.log.date).format('DD-MM-YYYY')}.`
                    } else if(status == 'manual_cash') {
                        message = `Contante betaling (cash) aangenomen van € ${parseFloat(this.log.longtext).toFixed(2)} op ${moment(this.log.date).format('DD-MM-YYYY')}.`
                    }

                    // Add extra message if payment is on hold
                    if(this.log.type == 'create_invoice_payment_hold')
                        message += ' De betaling is tijdelijk geblokkeerd tot het contract is getekend.'

                    return message;
                break;
                case 'invoice_credited':
                    if(status == 'manual')
                        return `Handmatige overboeking gedaan van € ${parseFloat(this.log.longtext).toFixed(2)} op ${moment(this.log.date).format('DD-MM-YYYY')}.`
                    else if(status == 'manual_cash')
                        return `Contante betaling (cash) gedaan van € ${parseFloat(this.log.longtext).toFixed(2)} op ${moment(this.log.date).format('DD-MM-YYYY')}.`
                break;
                case 'invoice_paid':
                    return 'De factuur is volledig betaald.'
                case 'create_invoice':
                case 'create_separated_invoice':
                    if (!_.isNull(this.log.date)){
                        return `Nieuwe factuur aangemaakt voor ${moment(this.log.date).format('DD-MM-Y')}.`
                    } else {
                        return 'Nieuwe factuur aangemaakt.'
                    }
                case 'create_partial_invoice':
                    return `Nieuwe factuur aangemaakt voor een gedeeltelijke periode tot ${moment(this.log.date).format('DD-MM-Y')}.`
                break;
                case 'payment_adjusted':
                    if (this.log.longtext == 'incasso') {
                        return 'Geplande incasso aangepast vanwege gedeeltelijke handmatige betaling.'
                    } else {
                        return 'Handmatige openstaande betaling is gedeeltelijk betaald.'
                    }
                // case 'pdf_regenerated':
                //     return 'Factuur PDF is (opnieuw) gegenereerd.'
                break;
                case 'message':
                    return this.log.longtext
                break;
                case 'send_invoice_reminder1':
                    return 'E-mail verstuurd voor 1e betaalherinnering.'
                case 'send_invoice_reminder2':
                    return 'E-mail verstuurd voor 2e betaalherinnering.'
                case 'send_invoice_reminder3':
                    return 'E-mail verstuurd voor 3e betaalherinnering.'
                break;
                case 'send_contract_sign_mail':
                    return 'E-mail verstuurd met link om documenten te ondertekenen.'
                break;
                case 'planned':
                    if(this.log.longtext){
                        return `Incasso aangemeld bij Pay.nl voor een bedrag van € ${this.log.longtext}`
                    } else {
                        return 'Incasso aangemeld bij Pay.nl.'
                    }
                break;
                case 'paynl_checked_not_paid':
                    this.type = 'simple'
                    return 'Betaling gecontroleerd maar is nog niet uitgevoerd door Pay.nl.'
                break;
                case 'paynl_incasso_error':
                    return 'Pay.nl geeft error ('+this.log.longtext+') terug voor deze transactie.'
                break;
                case 'incasso_planned':
                    return 'Nieuwe incasso opdracht ingepland.'
                break;
                case 'invoice_auto_escalated':
                    return 'Factuur is automatisch geëscaleerd (dossier: '+this.log.longtext+').'
                break;
                case 'paynl_payment_planned_bank':
                    return 'De incasso is door Pay.nl in een batch geplaatst en is aangeboden bij de bank.'
                break;
                case 'incasso_storno':
                    return 'De incasso-opdracht ('+this.log.longtext+') van '+moment(this.log.date).format('DD-MM-Y')+' is gestorneerd, mandaat '+this.log.status+' is verwijderd uit het contract.'
                break;
                case 'mandate_deleted_banknumber':
                    return 'Het incassomandaat ('+this.log.longtext+') is verwijderd omdat het bankrekeningnummer van de klant is gewijzigd.'
                break;
                case 'resend_invoice':
                    return 'De factuur is ingepland om opnieuw te worden verzonden.'
                break;
                // case 'create_separated_invoice':
                //     return 'Nieuwe factuur aangemaakt.'
                // break;
                case 'create_credit_invoice':
                case 'create_separated_credit':
                case 'credit_created_standalone':
                    return 'Nieuwe creditfactuur aangemaakt.'
                break;
                case 'credit_created_for_invoice':
                    return 'Creditfactuur aangemaakt voor deze factuur.'
                break;
                case 'credit_payment_applied':
                    return 'Betaling toegevoegd via creditfactuur (€ '+parseFloat(this.log.longtext).toFixed(2)+').'
                break;
                case 'credit_outgoing_payment':
                    if(this.log.longtext == '0') {
                        return 'Creditfactuur aangemaakt voor factuur.'
                    } else {
                        return 'Verekening via creditfactuur toegepast op factuur (€ '+parseFloat(this.log.longtext).toFixed(2)+').'
                    }
                break;
                case 'invoice_cancelled_contract':
                    return `Factuur is geannuleerd omdat het contract beëindigd is per ${moment(this.log.date).format('DD-MM-Y')}.`
                break;
                case 'creditinvoice_cancelled':
                    return 'Creditfactuur is geannuleerd.'
                break;
                case 'invoice_cancelled':
                    return 'Factuur is geannuleerd.'
                break;
                case 'invoice_mail_deferred':
                    return 'Verzenden factuur mislukt, contract is nog niet ondertekend door klant. Dit wordt opnieuw geprobeerd over 6 uur.'
                break;
                case 'payment_cancelled':
                    return `Betaling voor ${moment(this.log.date).format('DD-MM-Y')} is geannuleerd.`
                    // reden wordt uit de longtext gehaald
                case 'payment_released_from_hold':
                    return 'Betaling is vrijgegeven van de blokkade omdat het contract is getekend.'
                case 'invoice_products_changes':
                    return this.log.longtext
                case 'invoice_contract_pricechange':
                    return `Factuur is geannuleerd door een prijswijziging voor het bijbehorende contract vanaf ${moment(this.log.date).format('DD-MM-Y')}.`
                break;
                case 'contract_pricechange':
                    return `Prijzen van producten in contract zijn aangepast door een prijswijziging vanaf ${moment(this.log.date).format('DD-MM-Y')}.`
                break;
                case 'invoice_contract_addendum':
                    return `Factuur is geannuleerd en opnieuw ingepland vanwege een contractaanpassing.`
                break;
                case 'invoice_restored':
                    return `Factuurannulering is ongedaan gemaakt.`

                case 'mandate_approved_payment_rescheduled':
                    return `Incasso van ${moment(this.log.date).format('DD-MM-Y')} is opnieuw ingepland voor vandaag na succesvolle goedkeuring van het incassomandaat.`
                break;
                case 'payment_queued_pending_mandate':
                    return `Incasso van ${moment(this.log.date).format('DD-MM-Y')} is in een wachtrij geplaatst totdat het incassomandaat is goedgekeurd.`
                break;
                case 'payment_queued_pending_addendum':
                    return `Incasso van ${moment(this.log.date).format('DD-MM-Y')} is in een wachtrij geplaatst totdat de contractaanpassing is ondertekend.`
                break;
                case 'addendum_approved_payment_rescheduled':
                    return `Incasso is opnieuw ingepland voor vandaag omdat de contractaanpassing is bevestigd.`
                break;
                case 'payment_cancelled_mandate_revoked':
                    return `Wachtende incasso is geannuleerd omdat het incassomandaat is ingetrokken.`
                break;
                case 'payment_cancelled_mandate_failed':
                    return `Wachtende incasso is geannuleerd omdat het incassomandaat niet is goedgekeurd.`
                break;
                case 'mandate_failed':
                    return `Incassomandaat (${this.log.longtext}) is niet is goedgekeurd.`
                break;
                case 'mandate_activated':
                    return `Incassomandaat (${this.log.longtext}) is geactiveerd door Pay.nl.`
                break;
                case 'mandate_revoked_storno':
                    return `Incassomandaat (${this.log.longtext}) is ingetrokken vanwege een stornering.`
                break;
                case 'send_storno_mail':
                    return 'E-mail verstuurd m.b.t. stornering.'
                break;
                case 'invoice_escalated':
                    return `Factuur is geëscaleerd (dossier: ${this.log.longtext}). Binnen enkele minuten zal er een escalatiepakket worden aangemaakt.`
                break;
                case 'escalation_package_created':
                    return 'Escalatiepakket is aangemaakt.'
                case 'escalation_download':
                    if(!_.isNull(this.log.longtext)) {
                        return `Escalatiepakket is gedownload (door ${this.log.longtext}).`
                    }
                    return `Escalatiepakket is gedownload.`
                break;
                case 'send_mail_escalation':
                    return 'Escalatiepakket is intern verzonden.'
                break;
                case 'send_mail_escalation_out':
                    return 'Escalatiepakket is verzonden naar de deurwaarder.'
                break;
                case 'invoice_escalation_status':
                    if(this.log.status == 'escalated_done'){
                        return 'Escalatie is gemarkeerd als afgerond.'
                    } else {
                        return 'Escalatie is opnieuw geopend.'
                    }
                case 'escalation_notify':
                    return 'De klant is op de hoogte gesteld per e-mail over de escalatie van de factuur.'
                break;
                case 'payment_error':
                    return 'Betaling is mislukt.'

                // Contract types
                case 'contract_created':
                    return 'Contract is aangemaakt.'
                break;
                case 'send_contract_mail':
                    return 'E-mail verstuurd met de overeenkomst in de bijlage.'
                break;
                case 'document_signed':
                    return `Document "${this.log.longtext}" is getekend.`
                break;
                case 'contract_file_uploaded':
                    return 'Bestand toegevoegd.'
                break;
                case 'contract_file_deleted':
                    return `Bestand verwijderd (${this.log.longtext}).`
                break;
                case 'contract_file_deleted':
                    return `Einddatum contract is opgegeven voor ${moment(this.log.date).format('DD-MM-Y')}.`
                break;
                case 'contract_extended':
                    if (!_.isNull(this.log.date)){
                        return `Contract is verlengd tot ${moment(this.log.date).format('DD-MM-Y')}. Vorige einddatum: ${moment(this.log.longtext).format('DD-MM-Y')}.`
                    } else {
                        return `Contract is verlengd zonder einddatum. Vorige einddatum: ${moment(this.log.longtext).format('DD-MM-Y')}.`
                    }
                break;
                case 'contract_stopped':
                    if (!_.isNull(this.log.date)){
                        return `Contract is beëindigd per ${moment(this.log.date).format('DD-MM-Y')}.`
                    } else {
                        return `Contract is per direct beëindigd.`
                    }
                break;
                case 'mail_end_contract':
                    if (!_.isNull(this.log.date)){
                        return `E-mail verstuurd naar klant dat het contract per ${moment(this.log.date).format('DD-MM-Y')} beëindigd is.`
                    } else {
                        return `E-mail verstuurd naar klant dat het contract per direct beëindigd is.`
                    }
                break;
                case 'mandate_removed': // deprecated
                case 'customer_mandate_removed':
                    return `Mandaat (${this.log.longtext}) is verwijderd.`
                break;
                case 'contract_auto_escalate':
                    return 'Nieuwe facturen voor dit contract worden automatisch geëscaleerd wanneer ze worden aangemaakt.'
                break;
                case 'contract_auto_escalate_disabled':
                    return 'Automatisch escaleren is uitgeschakeld voor dit contract.'
                break;
                case 'contract_fully_signed':
                    return 'Alle contractdocumenten zijn getekend.'
                break;
                case 'contract_addendum_requested':
                    return `Contractaanpassing is aangemaakt met ingangsdatum ${moment(this.log.date).format('DD-MM-Y')}.`
                break;
                case 'contract_addendum_applied':
                    return 'Contractaanpassing is verwerkt.'
                break;
                case 'invoice_contract_addendum_restored':
                    return 'Factuur is hersteld vanwege niet op tijd accepteren van een contractaanpassing'
                case 'contract_addendum_cancelled':
                    return `Contractaanpassing ${this.log.longtext} is geannuleerd.`
                break;
                case 'mail_contract_addendum_changed':
                    return 'E-mail verstuurd naar klant dat de contractaanpassing is gewijzigd.'
                break;
                case 'mail_contract_addendum_cancelled':
                    return 'E-mail verstuurd naar klant dat de contractaanpassing is geannuleerd.'
                break;
                case 'contract_addendum_expired':
                    return 'Contractaanpassing is niet op tijd ondertekend en is geannuleerd.'
                break;
                case 'customer_mail':
                    return this.log.longtext
                break;
                case 'payment_type_changed':
                    let paymentTypeText = this.log.longtext
                        .replace('manual_cash', 'contante betaling (cash)')
                        .replace('manual', 'handmatige betaling (overschrijving)')
                    return `${paymentTypeText}.`
                break;
                case 'customer_deleted':
                    return 'Klant is verwijderd.'
                break;
                default:
                    return type
                break;
            }
        },

        viewFile(filePath) {
            this.$emit('setLoading', true)
            window.open('/uploads'+filePath, '_blank')

            setTimeout(() => {
                this.$emit('setLoading', false)
            }, 1000)
        }
    }

}
</script>
